import { State } from 'src/replicant/State';
import { shopBundlesPacks } from './match2-shopbundles.ruleset';
import { ProductId, gemsRewardTable } from 'src/replicant/iap/iap.ruleset';
import { processMatch2Rewards } from '../rewards/match2-rewards.getters';
import {
  BundleSaleProductId,
  bundleSaleProducts,
} from '../bundlesale/match2-bundlesale.ruleset';
import { match2BundleSaleGetPackRewardSet } from '../bundlesale/match2-bundlesale.getters';
import {
  FixedBPointsReward,
  Match2Reward,
} from '../rewards/match2-rewards.ruleset';
/**
 * Retrieves the rewards for a given product based on whether it is a bundle sale product or a regular shop bundle.
 *
 * @param productId - The ID of the product for which to get rewards.
 * @param now - The current timestamp used to determine the rewards.
 * @returns An array of Match2Reward objects corresponding to the product.
 */
export function getRewards(productId: ProductId, now: number): Match2Reward[] {
  return isBundleSaleProduct(productId)
    ? match2BundleSaleGetPackRewardSet(productId as BundleSaleProductId, now)
    : shopBundleGetPackRewardSet(productId, now);
}

/**
 * Check if product id refers to a bundle sale product
 */
function isBundleSaleProduct(id: ProductId): boolean {
  return bundleSaleProducts.includes(id as BundleSaleProductId);
}

/**
 * Check if product id refers to a shop bundle pack
 */
export function shopBundlesIsPack(id: ProductId): boolean {
  return !!shopBundlesPacks[id];
}

/**
 * Get bundle pack data by product id
 */
export function shopBundlesGetPack(id: ProductId) {
  return shopBundlesPacks[id];
}

/**
 * Get gems reward of a product - sum of paidGems and freeGems
 */
export function shopBundlesGetGemsReward(id: ProductId): number {
  const reward = gemsRewardTable[id];
  return (reward.paidGems ?? 0) + (reward.freeGems ?? 0);
}

/**
 * Get coins (bPoints) reward of a product
 */
export function shopBundlesGetCoinsReward(id: ProductId): number {
  const pack = shopBundlesGetPack(id);
  const coinsReward = pack?.rewards.find(
    (reward) => reward.type === 'bPoints',
  ) as FixedBPointsReward | undefined;
  return coinsReward?.amount ?? 0;
} /**
 * Get the price of a product in USD cents
 */
export function shopBundlesHasPurchasedStarterPack(state: State): boolean {
  return state.match2.shopBundles?.starterPackPurchased ?? false;
}

/**
 * Check if user has purchased the pet starter pack
 */
export function shopBundlesHasPurchasedPetStarterPack(state: State): boolean {
  return state.match2.shopBundles?.petStarterPackPurchased ?? false;
}

/**
 * Get reward set from a product pack
 */
export function shopBundleGetPackRewardSet(
  id: ProductId,
  now: number,
): Match2Reward[] {
  const pack = shopBundlesGetPack(id);
  if (!pack) return [];
  return processMatch2Rewards(pack.rewards, now);
}
